module.exports = __webpack_public_path__ + "fonts/MING_MSCS.bd6bf1f9.eot";